import nopInstance from "../nopInstance.js"

const config = {
    headers: {
    'Content-Type': 'application/json',
    },
};

const getProductsByIds = async (ids) => {
    // Set the Content-Type header to application/json
    
    
    const response = await nopInstance.get(`api/product?productId=${ids}`, config);
    return response;
}

const getProductPriceAndStock = async(ids) => {
    return await nopInstance.get(`api/product/pricing?ids=${ids}`)
}

export default {
    getProductsByIds,
    getProductPriceAndStock
}